<template>
  <div class="recipe-community">
    <div v-if="posts.length === 0" class="empty-state">
      <p>成為第一個分享作品的人，上傳你的烹飪成果吧！</p>
    </div>
    <div v-else class="community-posts">
      <div
        v-for="post in posts"
        :key="post.id"
        class="community-post"
        @click="handlePostClick(post.id)"
      >
        <img :src="post.imageUrl" :alt="post.content" class="post-image" />
        <div class="post-content">
          <div class="post-user">
            <img
              :src="post.icon"
              :alt="post.publisher"
              class="post-user-avatar"
            />
            <div class="post-user-name">{{ post.publisher }}</div>
          </div>
          <p class="post-text">{{ post.content }}</p>
          <div class="post-meta">
            <span><i class="fas fa-heart"></i> {{ post.likes }}</span>
            <span><i class="fas fa-comment"></i> {{ post.comments }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeCommunity",
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["post-click"],
  methods: {
    handlePostClick(postId) {
      this.$emit("post-click", postId);
    },
  },
};
</script>

<style scoped>
.recipe-community {
  margin-top: 16px;
}

.empty-state {
  padding: 24px 16px;
  text-align: center;
  color: var(--text-secondary);
}

.community-posts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.community-post {
  background: var(--card-background);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.community-post:hover {
  transform: translateY(-2px);
}

.post-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.post-content {
  padding: 12px;
}

.post-user {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.post-user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.post-user-name {
  font-weight: 600;
  font-size: 0.9rem;
}

.post-text {
  font-size: 0.9rem;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.post-meta {
  display: flex;
  gap: 12px;
  color: var(--text-secondary);
  font-size: 0.8rem;
}
</style>
